module.exports = __webpack_public_path__ + "bg_thumb.png?cab3529a651e084d6717a90bdff08a09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_thumb.png
// module id = 59
// module chunks = 0